import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select } from 'redux-saga/effects';
import { all } from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';
import { useContext } from 'react';
import { AuthContext } from '@utils/DOIgnition/AuthContext';

function* fetchDSConfig(action: actionsInterfaces.IFetchDSConfigAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const role = action.dealerUserData.role;
    const email = action.dealerUserData.email;
    const organizations = action.dealerUserData.organizations?(Array.isArray(action.dealerUserData.organizations)?action.dealerUserData.organizations.join(','):action.dealerUserData.organizations):null;
    const response: AxiosResponse<any> = yield axios.get(`${host}dsconfig?role=${role}&email=${email}&organizations=${organizations}`,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.dsConfig.setDSConfig(response.data[0]));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addOEMColor(action: actionsInterfaces.ISetOEMColor) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let colorAction = "add";
    if (action.modifyLastColor) {
      colorAction = "modify";
    }
    const response: AxiosResponse<any> = yield axios.post(`${host}oem/${action.oem}/color/${action.color.replace("#","")}/action/${colorAction}`, action.dealerUserData, {headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      //to improve do not refresh dsconfig when adding OEMColor, it is not necessary
      //yield put(actions.dsConfig.setDSConfig(response.data[0]));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.FETCH_DSCONFIG, fetchDSConfig),
    takeLatest(actionsTypes.ADD_OEM_COLOR, addOEMColor)
  ])
}

